export default __webpack_public_path__ + "static/media/element_36.e48eac49.webp";